export const REFETCH_SEARCH = "REFETCH_SEARCH"
export const SET_SELECTED_USER = "SET_SELECTED_USER"
export const CLEAR_SELECTED_USER = "CLEAR_SELECTED_USER"
export const SET_SELECTED_USER_URL = "SET_SELECTED_USER_URL"
export const CLEAR_SELECTED_USER_URL = "CLEAR_SELECTED_USER_URL"
export const RECEIVE_USER_SEARCH = "RECEIVE_USER_SEARCH"
export const RECEIVE_USER_SEARCH_FINAL = "RECEIVE_USER_SEARCH_FINAL"
export const FETCH_USER_SEARCH = "FETCH_USER_SEARCH"
export const FETCH_USER_SEARCH_NEXT_PAGE = "FETCH_USER_SEARCH_NEXT_PAGE"
export const RECEIVE_INITIAL_SEARCH_ERROR = "RECEIVE_INITIAL_SEARCH_ERROR"
export const RECEIVE_NEXT_PAGE_ERROR = "RECEIVE_NEXT_PAGE_ERROR"
export const FETCH_SELECTED_USER = "FETCH_SELECTED_USER"
export const RECEIVE_SELECTED_USER = "RECEIVE_SELECTED_USER"
export const FETCH_RECENT_SEARCHES = "FETCH_RECENT_SEARCHES"
export const RECEIVE_RECENT_SEARCHES = "RECEIVE_RECENT_SEARCHES"
export const CLEAR_QUERY = "CLEAR_QUERY"
export const RECEIVE_SEARCH_TEXT_SUGGESTIONS = "RECEIVE_SEARCH_TEXT_SUGGESTIONS"
export const FETCH_SEARCH_TEXT_SUGGESTIONS = "FETCH_SEARCH_TEXT_SUGGESTIONS"
export const CLEAR_SEARCH_SUGGESTIONS = "CLEAR_SEARCH_SUGGESTIONS"
export const FETCH_MAP_LOCATIONS = "FETCH_MAP_LOCATIONS"
export const RECEIVE_MAP_LOCATIONS = "RECEIVE_MAP_LOCATIONS"
export const TURN_ON_MAP_VIEW = "TURN_ON_MAP_VIEW"
export const TURN_OFF_MAP_VIEW = "TURN_OFF_MAP_VIEW"
export const FETCH_SUGGESTED_SEARCHES = "FETCH_SUGGESTED_SEARCHES"
export const RECEIVE_SUGGESTED_SEARCHES = "RECEIVE_SUGGESTED_SEARCHES"
export const CLICK_SEARCH_CARD = "CLICK_SEARCH_CARD"
export const HIDE_MAP_CTA = "HIDE_MAP_CTA"
export const RECEIVE_VOLUNTEER_ROLES = "RECEIVE_VOLUNTEER_ROLES"

export const fetchRecentSearches = () => ({
  type: FETCH_RECENT_SEARCHES,
})

export const hideMapCTA = () => ({
  type: HIDE_MAP_CTA,
})

export const fetchSearchSuggestions = (query) => ({
  type: FETCH_SEARCH_TEXT_SUGGESTIONS,
  query,
})

export const clearSearchSuggestions = () => ({
  type: CLEAR_SEARCH_SUGGESTIONS,
})

export const receiveRecentSearches = (searches) => ({
  type: RECEIVE_RECENT_SEARCHES,
  searches,
})

export const receiveSearchSuggestions = (suggestedSearches) => ({
  type: RECEIVE_SEARCH_TEXT_SUGGESTIONS,
  suggestedSearches,
})

export const refetchSearch = (success) => ({
  type: REFETCH_SEARCH,
  success,
})

export const fetchSelectedUser = (userId, customerId, error, generation) => ({
  type: FETCH_SELECTED_USER,
  userId,
  customerId,
  error,
  generation,
})

export const receiveSelectedUser = (user) => ({
  type: RECEIVE_SELECTED_USER,
  user,
})

export const setSelectedUser = (userId, customerId, error) => ({
  type: SET_SELECTED_USER,
  userId,
  customerId,
  error,
})

export const setSelectedUserUrl = (userId, customerId) => ({
  type: SET_SELECTED_USER_URL,
  userId,
  customerId,
})

export const clearSelectedUser = () => ({
  type: CLEAR_SELECTED_USER,
})

export const clearSelectedUserUrl = (history) => ({
  type: CLEAR_SELECTED_USER_URL,
  history,
})

export const fetchUserSearchNextPage = (page) => ({
  type: FETCH_USER_SEARCH_NEXT_PAGE,
  page,
})

export const fetchUserSearch = (params, history, success) => ({
  type: FETCH_USER_SEARCH,
  params,
  history,
  success,
})

export const fetchUserSearchClean = (params, success) => ({
  type: FETCH_USER_SEARCH,
  params,
  success,
})

export const receiveUserSearch = (response, selectedUserId, filters) => ({
  type: RECEIVE_USER_SEARCH,
  response,
  selectedUserId,
  filters,
})

export const receiveUserSearchFinal = (
  response,
  selectedUserId,
  newFilters,
  newExplanation,
  results,
  oldQuery,
) => ({
  type: RECEIVE_USER_SEARCH_FINAL,
  response,
  selectedUserId,
  newFilters,
  newExplanation,
  results,
  oldQuery,
})

export const receiveInitialSearchError = (response) => ({
  type: RECEIVE_INITIAL_SEARCH_ERROR,
  response,
})

export const clearQuery = () => ({
  type: CLEAR_QUERY,
})

export const receiveNextPageError = (response) => ({
  type: RECEIVE_NEXT_PAGE_ERROR,
  response,
})

export const fetchMapLocations = (query, filters, success, error) => ({
  type: FETCH_MAP_LOCATIONS,
  query,
  filters,
  success,
  error,
})

export const receiveMapLocations = (locations, query) => ({
  type: RECEIVE_MAP_LOCATIONS,
  locations,
  query,
})

export const turnOnMapView = () => ({
  type: TURN_ON_MAP_VIEW,
})

export const turnOffMapView = () => ({
  type: TURN_OFF_MAP_VIEW,
})

export const clickSearchCard = (clickedUser, currentUser, params) => ({
  type: CLICK_SEARCH_CARD,
  clickedUser,
  currentUser,
  params,
})

export const receiveSuggestedSearches = (suggestedSearches) => ({
  type: RECEIVE_SUGGESTED_SEARCHES,
  suggestedSearches,
})

export const fetchSuggestedSearches = (page, success, error) => ({
  type: FETCH_SUGGESTED_SEARCHES,
  page,
  success,
  error,
})

export const receiveVolunteerRoles = (volunteerRoles) => ({
  type: RECEIVE_VOLUNTEER_ROLES,
  volunteerRoles,
})
